import {
  Grid,
  Row,
  Column,
  Modal,
} from "carbon-components-react";
import { OpenPanelFilledRight16 } from "@carbon/icons-react"
import ComboBox from "forms/inputs/ComboBox/ComboBox";
import Toggle from "forms/inputs/Toggle/Toggle";
import ContentSwitcher from "forms/inputs/ContentSwitcher/ContentSwitcher";
import MultiSelect from "forms/inputs/MultiSelect/MultiSelect";
import RichTextArea from "./RichTextArea/RichTextArea";
import EditableList from "components/EditableList/EditableList";
import Datetime from "./Datetime/Datetime";
import ColorPicker from "./ColorPicker/ColorPicker";
import SpeakerBio from "./SpeakerBio/SpeakerBioV2";
import InputValueDifference from "forms/inputs/InputValueDifference/InputValueDifference"
import { useState } from "react";
import Domain from "./Domain/Domain";
import TagList from "./TagList/TagList";
import IconSelector from "./IconSelector/IconSelector";
import ChannelSources from "./ChannelSources/ChannelSources";
import ClosedCaptions from "./ClosedCaptions/ClosedCaptions";
import SpeakersList from "./SpeakersList/SpeakersList";
import AdamTextInput from "./AdamTextInput/AdamTextInput";
import AdamPasswordInput from "./AdamPasswordInput/AdamPasswordInput";
import AdamNumberInput from "./AdamNumberInput/AdamNumberInput";
import AdamTextArea from "./AdamTextArea/AdamTextArea";
import HideSpeakers from "./HideSpeakers/HideSpeakers";
import AceEditor from "./AceEditor/AceEditor";
import QuizQuestionOptions from "./QuizQuestionOptions/QuizQuestionOptions";
import AdamVideoUrlTextInput from "./AdamVideoUrlTextInput/AdamVideoUrlTextInput";

const Input = (props) => {

  const [modalOpen, setModalOpen] = useState(false)
  const [originalContent, setOriginalContent] = useState()
  const [currentContent, setCurrentContent] = useState()

  const openModal = (oc, cc) => {
    setOriginalContent(oc)
    setCurrentContent(cc)
    setModalOpen(true)
  }

  const onModalRequestClose = () => {
    setOriginalContent()
    setCurrentContent()
    setModalOpen(false)
  }

  let inputElement = null;
  const name = props.id
  const cleanProps = () => {
    let {
      id,
      value,
      elementType,
      register,
      control,
      labelOn,
      labelOff,
      selectedItem,
      original,
      compareValues,
      height,
      ...cleanProps
    } = props;
    return {
      ...cleanProps,
      id: props.id,
      name: name,
      height
      // value: (value === null) ? undefined : value
    };
  };

  switch (props.elementType) {
    case "input":
    case "email":
      // <label>{label}</label>
      // <input name={name} ref={register({ required })} />
      // <p>{errors.firstName?.message}</p>
      // required
      // min
      // max
      // minLength
      // maxLength
      // pattern
      // validate
      inputElement = (
        <AdamTextInput
          // ref={props.register({name: props.name}, props.rules)}
          // defaultValue={props.defaultValue}
          // helperText="Optional helper text here; if message is more than one line text should wrap (~100 character count maximum)"
          // id="test2"
          // invalidText="Invalid error message."
          // labelText="Text input label"
          // placeholder="Placeholder text"

          // DO NOT REMOVE
          value={props.value}
          {...cleanProps()}
        />
      );
      break;
    case "video_url":
      inputElement = (
        <AdamVideoUrlTextInput
          value={props.value}
          {...cleanProps()}
        />
      )
      break
    case "domain":
      // <label>{label}</label>
      // <input name={name} ref={register({ required })} />
      // <p>{errors.firstName?.message}</p>
      // required
      // min
      // max
      // minLength
      // maxLength
      // pattern
      // validate
      inputElement = (
        <Domain
          // ref={props.register({name: props.name}, props.rules)}
          // defaultValue={props.defaultValue}
          // helperText="Optional helper text here; if message is more than one line text should wrap (~100 character count maximum)"
          // id="test2"
          // invalidText="Invalid error message."
          // labelText="Text input label"
          // placeholder="Placeholder text"

          // DO NOT REMOVE
          value={props.value}
          {...cleanProps()}
        />
      );
      break;
    case "password":
      inputElement = (
        <AdamPasswordInput
          hidePasswordLabel="Hide password"
          {...cleanProps()}
          showPasswordLabel="Show password"
          value={props.value}
        />
      );
      break;
    case "number":
      // <label>{label}</label>
      // <input name={name} ref={register({ required })} />
      // <p>{errors.firstName?.message}</p>
      // required
      // min
      // max
      // minLength
      // maxLength
      // pattern
      // validate
      inputElement = (
        <AdamNumberInput
          // ref={props.register({name: props.name}, props.rules)}
          // defaultValue={props.defaultValue}
          // helperText="Optional helper text here; if message is more than one line text should wrap (~100 character count maximum)"
          // id="test2"
          // invalidText="Invalid error message."
          // labelText="Text input label"
          // placeholder="Placeholder text"

          // DO NOT REMOVE
          // value={props.value}
          {...cleanProps()}
        />
      );
      break;
    case "textarea":
      inputElement = (
        <AdamTextArea
          // defaultValue={props.defaultValue}
          //   ref={props.register(props.rules)}
          // cols={50}
          // helperText="Optional helper text here; if message is more than one line text should wrap (~100 character count maximum)"
          // id="test5"
          // invalidText="Invalid error message."
          // labelText="Text area label"
          // placeholder="Placeholder text"
          // rows={4}
          {...cleanProps()}
        />
      );
      break;
    case "wysiwyg":
      const wysiwygProps = {
        ...cleanProps(),
        value: props.value
      }
      inputElement = (
        <RichTextArea {...wysiwygProps} />
      );
      break;
    case "help":
      inputElement = (
        <div>{props.content}</div>
      );
      break;
    case "toggle":
      inputElement = (
        <Toggle
          aria-label={cleanProps().id}
          defaultToggled={props.defaultValue}
          id={cleanProps().id}
          name={cleanProps().name}
          labelText={props.labelText}
          onToggle={(e) => props.onChange(e)}
          labelA={props.labelOff}
          labelB={props.labelOn}
          disabled={props.disabled}
        // toggled={props.defaultValue}
        />
      );
      break;
    case "radio-buttons":
      inputElement = (
        <ContentSwitcher
          aria-label={cleanProps.id}
          id={props.id}
          labelText={props.labelText}
          onChange={(e) => props.onChange(e)}
          selectedIndex={props.defaultValue}
          items={props.items}
          firstIndex={props.firstIndex === undefined || props.firstIndex === null ? 1 : props.firstIndex}
        />
      );
      break;
    case "hidden":
      inputElement = (
        <input
          type={"hidden"}
          id={cleanProps.id}
          name={cleanProps.id}
          value={props.defaultValue}
        />
      );
      break;
    case "select":
      inputElement = (
        <ComboBox
          ariaLabel={props.id}
          id={props.id}
          items={props.items || []}
          label={props.label}
          titleText={props.label}
          helperText={props.helperText}
          invalid={props.invalid}
          onChange={(e) => props.onChange(e)}
          invalidText={props.helperText}
          labelText={props.labelText}
          placeholder={props.placeholder}
          defaultValue={props.defaultValue}
          loading={props.loading}
          readOnly={props.readOnly}
          disabled={props.disabled}
        // initialSelectedItem={{
        //     id:props.value,
        //     label:props.value
        // }}
        />
        // <Controller
        //   control={props.control}
        //   name={cleanProps.id}
        //   rules={props.rules}
        //   render={() => {
        //       console.log("Controller",props)
        //     return (
        //       <ComboBox
        //         ariaLabel="ComboBox"
        //         id={cleanProps.id}
        //         items={props.items}
        //         label={props.label}
        //         titleText={props.label}
        //         helperText={props.helperText}
        //         invalid={props.invalid}
        //         onChange={(e) => props.onChange(e, props.name)}
        //         invalidText={props.helperText}
        //         labelText={props.labelText}
        //         placeholder={props.placeholder}
        //         initialSelectedItem={{
        //             id:props.defaultValue,
        //             label:props.defaultValue
        //         }}
        //       />
        //     );
        //   }}
        // />
      );
      break;
    case "multiselect":
      // console.log("multiselect", props)
      inputElement = (
        <MultiSelect
          key={`multiselect-${cleanProps.id}`}
          ariaLabel={props.name}
          id={cleanProps.id}
          items={props.items}
          headers={props.headers}
          labelText={props.labelText}
          titleText="Filterable multiselect title"
          onChange={props.onChange}
          initialSelectedItem={props.defaultValue}
          disabledItems={props.disabledItems}
          hiddenItems={props.hiddenItems}
          disableMaxHeight={props.disableMaxHeight}
        />
      );
      break;
    case "editable-list":
      inputElement = (
        <EditableList
          // ariaLabel={props.name}
          // id={cleanProps.id}
          // items={props.items}
          // headers={props.headers}
          // labelText={props.labelText}
          // titleText="Filterable multiselect title"
          // onChange={props.onChange}
          // initialSelectedItem={props.defaultValue}
          {...cleanProps()}
        />
      );
      break;
    case "datetime":
      inputElement = (
        <Datetime
          // ariaLabel={props.name}
          // id={cleanProps.id}
          // items={props.items}
          // headers={props.headers}
          // labelText={props.labelText}
          // titleText="Filterable multiselect title"
          // onChange={props.onChange}
          // initialSelectedItem={props.defaultValue}
          {...cleanProps()}
        />
      );
      break;
    case "taglist":
      inputElement = (
        <TagList
          // ariaLabel={props.name}
          // id={cleanProps.id}
          // items={props.items}
          // headers={props.headers}
          // labelText={props.labelText}
          // titleText="Filterable multiselect title"
          // onChange={props.onChange}
          // initialSelectedItem={props.defaultValue}
          {...cleanProps()}
        />
      );
      break;
    case "ace":
      inputElement = (
        <AceEditor
          value={props.defaultValue}
          {...cleanProps()}
        />
      );
      break;
    case "colorpicker":
      const sketchpickerProps = {
        ...cleanProps(),
        initialValue: props.defaultValue
      }
      inputElement = (
        <ColorPicker
          // ariaLabel={props.name}
          // id={cleanProps.id}
          // items={props.items}
          // headers={props.headers}
          // labelText={props.labelText}
          // titleText="Filterable multiselect title"
          // onChange={props.onChange}
          // initialSelectedItem={props.defaultValue}
          {...sketchpickerProps}
        />
      );
      break;
    case "speakerbio":
      const speakerBioProps = {
        ...cleanProps(),
        initialValue: props.defaultValue
      }
      inputElement = (
        <SpeakerBio
          // ariaLabel={props.name}
          // id={cleanProps.id}
          // items={props.items}
          // headers={props.headers}
          // labelText={props.labelText}
          // titleText="Filterable multiselect title"
          // onChange={props.onChange}
          // initialSelectedItem={props.defaultValue}
          {...speakerBioProps}
        />
      );
      break;
    case "speakerslist":
      inputElement = (
        <SpeakersList
          {...{
            ...cleanProps(),
            initialValue: props.defaultValue
          }}
        />
      );
      break;
    case "hidespeakers":
      inputElement = (
        <HideSpeakers
          {...{
            ...cleanProps(),
            initialValue: props.defaultValue
          }}
        />
      );
      break;
    case "channel_sources":
      const channelSourcesProps = {
        ...cleanProps(),
        initialValue: props.defaultValue
      }
      inputElement = (
        <ChannelSources
          // ariaLabel={props.name}
          // id={cleanProps.id}
          // items={props.items}
          // headers={props.headers}
          // labelText={props.labelText}
          // titleText="Filterable multiselect title"
          // onChange={props.onChange}
          // initialSelectedItem={props.defaultValue}
          {...channelSourcesProps}
        />
      );
      break;
    case "closed_captions":
      const closedCaptionsProps = {
        ...cleanProps(),
        initialValue: props.defaultValue
      }
      inputElement = (
        <ClosedCaptions
          {...closedCaptionsProps}
        />
      );
      break;
    case "iconselector":
      inputElement = (
        <IconSelector {...cleanProps()} />
      )
      break
    case "question-options":
      inputElement = (
        <QuizQuestionOptions {...cleanProps()} />
      )
      break

    default:
      inputElement = null;
  }

  // console.log("diff name", props.name)
  // console.log("diff original", props.name, props.original)
  // console.log("diff defaultValue", props.name, props.defaultValue)
  // // console.log("diff value", props.name, props.value)
  // console.log("diff props.original != props.defaultValue", props.name, props.original != props.defaultValue)

  const isHtml = ["wysiwyg"].includes(props.elementType)
  return (
    <div style={{ marginBottom: "2rem", position: "relative" }}>
      {
        (props.compareValues && props.original !== props.value) ? (
          <div style={{ top: 0, right: 0, position: "absolute" }} onClick={() => openModal(props.original, props.defaultValue)}>
            <OpenPanelFilledRight16 />
          </div>
        ) : null
      }
      {inputElement}
      <Modal
        open={modalOpen}
        // danger={true}
        // onRequestSubmit={() => onModalRequestSubmit()}
        onRequestClose={() => onModalRequestClose()}
        // onSecondarySubmit={() => onModalRequestClose()}
        primaryButtonText="Continue"
        secondaryButtonText="Cancel"
        passiveModal={true}
        modalHeading={props.labelText}
        hasForm
        size="lg">
        <Grid>
          <Row>
            <Column sm={6} lg={6}>
              <InputValueDifference value={originalContent} isHtml={isHtml} />
            </Column>
            <Column sm={6} lg={6}>
              <InputValueDifference value={currentContent} current isHtml={isHtml} />
            </Column>
          </Row>
        </Grid>
      </Modal>
    </div>
  );
};

export default Input;
